import { render, staticRenderFns } from "./DetailArticle.vue?vue&type=template&id=18665468&scoped=true&"
import script from "./DetailArticle.vue?vue&type=script&lang=js&"
export * from "./DetailArticle.vue?vue&type=script&lang=js&"
import style0 from "./DetailArticle.vue?vue&type=style&index=0&id=18665468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18665468",
  null
  
)

export default component.exports